var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{attrs:{"show":_vm.show,"z-index":99999}},[_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-icon"},_vm._l((5),function(v){return _c('span',{key:v})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }